function tuiDateClamp(date, min, max) {
    if (max && max < date) {
        return max;
    }
    if (min && min > date) {
        return min;
    }
    return date;
}

/**
 * Generated bundle index. Do not edit.
 */

export { tuiDateClamp };
